<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                md="3"
                xl="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in leave type here"
                  append-icon="search"
                  label="Search Leave Type"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                xl="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Leave Type's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                offset-md="4"
                xl="2"
                offset-xl="2"
              >
                <setup-leaves-types-dialog-create
                  v-if="$hasPermissionTo([
                    'update position approval level',
                    'create leave types'
                  ])"
                  :combined-leave-types="combinedLeaveTypes"
                  @created="refreshData"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredLeaveTypes"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.is_paid_leave="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.is_paid_leave"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.is_prorated="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.is_prorated"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.is_carry_forwardable="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.is_carry_forwardable"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.is_continuous="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.is_continuous"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.requires_document="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.requires_document"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.is_optional_leave_entitlement="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.is_optional_leave_entitlement"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.requires_reason="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.requires_reason"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>

                  <span
                    v-if="item.requires_reason && item.minimum_days_reason_required"
                    class="font-weight-bold"
                  >
                    ({{ item.minimum_days_reason_required }})
                  </span>
                </span>
              </div>
            </template>
            <template v-slot:item.notify_hr="{ item }">
              <div>
                <span>
                  <v-icon
                    v-if="item.notify_hr"
                    color="success"
                  >
                    mdi-check-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-close-outline
                  </v-icon>
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-leaves-types-dialog-edit
                  :leave-type="item"
                  @updated="refreshData"
                />
                <span class="mx-1" />
                <setup-leaves-types-dialog-delete
                  :leave-type="item"
                  @deleted="refreshData"
                />
              </span>
              <span v-else>
                <setup-leaves-types-dialog-restore
                  :leave-type="item"
                  @restored="refreshData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupLeavesTypesDialogCreate: () => import('@/components/setup/leaves/types/DialogCreate'),
      SetupLeavesTypesDialogEdit: () => import('@/components/setup/leaves/types/DialogEdit'),
      SetupLeavesTypesDialogDelete: () => import('@/components/setup/leaves/types/DialogDelete'),
      SetupLeavesTypesDialogRestore: () => import('@/components/setup/leaves/types/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Leave Types',
      }
    },
    data () {
      return {
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        leaveTypes: [],
        trashedLeaveTypes: [],
        headers: [
          {
            text: 'Leave Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Paid Leave',
            align: 'center',
            value: 'is_paid_leave',
            sortable: false,
          },
          {
            text: 'Prorated?',
            align: 'center',
            value: 'is_prorated',
            sortable: false,
          },
          {
            text: 'Carry Forward?',
            align: 'center',
            value: 'is_carry_forwardable',
            sortable: false,
          },
          {
            text: 'Is Continuous?',
            align: 'center',
            value: 'is_continuous',
            sortable: false,
          },
          {
            text: 'Requires Document',
            align: 'center',
            value: 'requires_document',
            sortable: false,
          },
          {
            text: 'Is Optional Entitlement?',
            align: 'center',
            value: 'is_optional_leave_entitlement',
            sortable: false,
          },
          {
            text: 'Requires Reason (Days)',
            align: 'center',
            value: 'requires_reason',
            sortable: false,
          },
          {
            text: 'Notify HR?',
            align: 'center',
            value: 'notify_hr',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        tableLoading: true,
        combinedLeaveTypes: [],
      }
    },
    computed: {
      filteredLeaveTypes () {
        return this.statusFilter ? this.leaveTypes : this.trashedLeaveTypes
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      refreshData () {
        Promise.all([
          this.$api.leaveTypes().list(),
          this.$api.leaveTypes().listTrashed(),
        ])
          .then(([leaveType, trashedLeaveType]) => {
            this.leaveTypes = leaveType.data        
            this.trashedLeaveTypes = trashedLeaveType.data
            
            this.combinedLeaveTypes = leaveType.data.concat(trashedLeaveType.data)

            this.tableLoading = false
          })
      },
    },
  }
</script>
